"use strict";
/**
 * Shared Billing Types for CafeMaster Pro
 *
 * This file contains all billing-related types used across services.
 * DO NOT MOVE THIS FILE - it is referenced by multiple microservices.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationRequestSchema = exports.LocationAddressSchema = exports.LocationPaymentStatusSchema = exports.LocationRequestStatusSchema = void 0;
const zod_1 = require("zod");
// ========================
// Location Billing Types
// ========================
exports.LocationRequestStatusSchema = zod_1.z.enum([
    'pending', 'approved', 'payment_pending', 'active', 'grace', 'inactive', 'rejected', 'cancelled'
]);
exports.LocationPaymentStatusSchema = zod_1.z.enum(['none', 'pending', 'active', 'past_due', 'cancelled']);
exports.LocationAddressSchema = zod_1.z.object({
    street: zod_1.z.string(),
    street2: zod_1.z.string().optional(),
    city: zod_1.z.string(),
    state: zod_1.z.string(),
    zip: zod_1.z.string(),
    country: zod_1.z.string().default('US'),
});
exports.LocationRequestSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    requestId: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.enum(['store', 'warehouse', 'popup']).optional(),
    address: exports.LocationAddressSchema,
    phone: zod_1.z.string(),
    timezone: zod_1.z.string(),
    ein: zod_1.z.string().optional(),
    legalEntityName: zod_1.z.string().optional(),
    stateTaxRate: zod_1.z.number().min(0).max(1),
    cityTaxRate: zod_1.z.number().min(0).max(1),
    operatingHours: zod_1.z.record(zod_1.z.any()).optional(),
    status: exports.LocationRequestStatusSchema,
    requestedAt: zod_1.z.string(),
    approvedAt: zod_1.z.string().optional(),
    approvedBy: zod_1.z.string().optional(),
    rejectedAt: zod_1.z.string().optional(),
    rejectedReason: zod_1.z.string().optional(),
    adminNotes: zod_1.z.string().optional(),
    infoRequested: zod_1.z.boolean().default(false),
    infoRequestMessage: zod_1.z.string().optional(),
    tenantResponse: zod_1.z.string().optional(),
    locationId: zod_1.z.string().optional(),
    stripeSubscriptionId: zod_1.z.string().optional(),
    stripeCheckoutSessionId: zod_1.z.string().optional(),
    paymentStatus: exports.LocationPaymentStatusSchema,
    gracePeriodEnds: zod_1.z.string().optional(),
    isFree: zod_1.z.boolean().default(false),
    priceId: zod_1.z.string().optional(),
    priceAmount: zod_1.z.number().optional(),
    stripeEventId: zod_1.z.string().optional(),
    statusRequestedAt: zod_1.z.string().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
//# sourceMappingURL=billing.js.map